var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-to-unlock",class:{unlocked: _vm.isUnlocked}},[_c('div',{staticClass:"dragdealer",attrs:{"id":"unlock-slider"}},[_c('p',[_vm._v(_vm._s(_vm.$t('poi.unlock_slider')))]),_c('div',{staticClass:"handle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }